/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParseSAMLIDPMetadataRequest
 */
export interface ParseSAMLIDPMetadataRequest {
    /**
     * 
     * @type {string}
     * @memberof ParseSAMLIDPMetadataRequest
     */
    url: string;
}

export function ParseSAMLIDPMetadataRequestFromJSON(json: any): ParseSAMLIDPMetadataRequest {
    return ParseSAMLIDPMetadataRequestFromJSONTyped(json, false);
}

export function ParseSAMLIDPMetadataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParseSAMLIDPMetadataRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ParseSAMLIDPMetadataRequestToJSON(value?: ParseSAMLIDPMetadataRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}


